import type { IMenuItem } from '@/shared/ui/menu.types';
import {
  getHelpCenterChapters,
  getHelpCenterRubricBySlug,
  type HelpCenterRubric as IRubric,
  type HelpCenterSection as ISection,
} from '@/shared/api/helpCenter';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePartnersStore = defineStore('partners store', () => {
  const partnersChapters = ref<ISection[]>();
  const partnersMenu = ref<IMenuItem[]>();
  const selectedRubric = ref<IRubric>();

  const setPartnersChapters = (data: ISection[]) => {
    partnersChapters.value = data;
  };

  const setSelectedRubric = (rubric: IRubric) => {
    selectedRubric.value = rubric;
  };

  const getPartnerChapters = async () => {
    try {
      const { data, error } = await getHelpCenterChapters({
        query: {
          section: 'partners',
        },
      });

      if (error || !data) {
        return;
      }

      const sections = data.results;
      sections.sort((a, b) => a.rank - b.rank);
      sections.forEach((section) => {
        section.rubrics.sort((a, b) => a.rank - b.rank);
      });

      partnersMenu.value = sections.map((section) => ({
        label: section.title,
        slug: section.slug,
        children: section.rubrics.map((rubric) => ({
          label: rubric.title,
          slug: rubric.slug,
        })),
      }));

      setPartnersChapters(data.results);

      return data;
    } catch {
      return;
    }
  };

  const getRubricInfo = async (slug: string) => {
    try {
      const { data, error } = await getHelpCenterRubricBySlug({
        path: {
          slug,
        },
      });

      if (error || !data) {
        return;
      }

      setSelectedRubric(data);

      return data;
    } catch {
      return;
    }
  };

  return {
    partnersChapters,
    partnersMenu,
    selectedRubric,

    getPartnerChapters,
    getRubricInfo,
  };
});
